import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "category-title" }
const _hoisted_2 = { class: "email-list" }
const _hoisted_3 = ["title", "onClick"]
const _hoisted_4 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("label", _hoisted_1, _toDisplayString(_ctx.GetEmailCategoryLabel(_ctx.emailType)), 1),
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.emailCategoryListing, (email) => {
        return (_openBlock(), _createElementBlock("li", {
          key: email.EmailType,
          class: _normalizeClass(["email-item", {active : _ctx.activeTab === email.EmailType}]),
          title: _ctx.GetTitlesForTooltip(email.EmailType),
          onClick: ($event: any) => (_ctx.SendSelectedEmailData(email))
        }, [
          _createElementVNode("img", {
            class: "margin-right-20",
            src: _ctx.GetImageSrc(_ctx.activeTab === email.EmailType,email.EmailType)
          }, null, 8, _hoisted_4),
          _createTextVNode(" " + _toDisplayString(email.Templates[0].EmailTypeProp), 1)
        ], 10, _hoisted_3))
      }), 128))
    ])
  ]))
}